import ServiceError from '../../core/errors/ServiceError';

export default async function loadServiceContextual(url) {
  if (!url) {
    return new ServiceError('No hay url para servicio de contextual', '00003');
  }
  const response = await fetch('https://cov1234test.pub.tappx.com/cov/v1/cplist.php', {
    method: 'POST',
    body: JSON.stringify({
      url,
    }),
  });
  let json;
  try {
    json = await response.json();
  } catch (error) {
    if (response?.status === 204) {
      return new ServiceError(
        'No hay contenido proporcionado por el servicio de Contextual',
        '00002',
      );
    }
    return new ServiceError('No se ha podido cargar el servicio de Contextual', '00001');
  }
  return json;
}
